export function senceFn(eventName, repjson) {
	// console.log(eventName);
	// console.log(repjson);
	// let url = 'https://sen.fcredit.kz/sa?project=Kazakhstan_Test' //测试
	let url = 'https://sen.fcredit.kz/sa?project=Kazakhstan' //正式
	let data = {
		"distinct_id": uni.getStorageSync('distinctid') || uni.getSystemInfoSync().deviceId,
		"time": new Date().getTime(),
		"type": eventName == '$BindID' ? 'track_id_bind' : 'track',
		"event": eventName,
		"properties": {
			"$app_id": "mfo.zaim.credit.bank.money.cash.tez.kml",
			"$app_version": '2.1.2',
			"$wifi": false,
			"$screen_width": uni.getSystemInfoSync().screenWidth,
			"$screen_height": uni.getSystemInfoSync().screenHeight,
			"platform_type": uni.getSystemInfoSync().osName,
			"app_type": 'App1',
			"channel": uni.getStorageSync('channel') || '',
			"is_login": uni.getStorageSync('token') == '' ? false : true,
			"platform_from": "h5"
		},
		"lib": {
			"$lib": "h5",
			"$app_version": '2.1.2',
		},
		"identities": {
			"distinct_id": uni.getStorageSync('distinctid') || uni.getSystemInfoSync().deviceId,
			"$identity_mobile": uni.getStorageSync('mobile') ? '7' + uni.getStorageSync('mobile') : ''
		}
	}
	for (let key in repjson) {
		data.properties[key] = repjson[key]
	}
	// console.log(data,'-----');
	const Base64Obj = {
		encode(str) {
			return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
				function toSolidBytes(match, p1) {
					return String.fromCharCode(Number('0x' + p1));
				}));
		},
		decode(str) {
			return decodeURIComponent(atob(str).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		}
	}
	let encodedstr = Base64Obj.encode(JSON.stringify(data, null, 2)); 
	var jsonDataStr = encodeURIComponent(encodedstr)
	uni.request({
		url,
		method: 'POST',
		data: 'data=' + jsonDataStr,
		success: res => {
			// console.log(res);
		},
		fail: (e) => {
			// console.log(e);
		}
	})
}
